
import {BrowserRouter,Routes,Route} from 'react-router-dom'
import Login from "./pages/login";
import Register from './pages/register';
import Layout from './components/Layout';
import Dashboard from './pages/Dashboard';
import Profile from './pages/profile';
import Forgetpassword from './pages/forgetpassword'
import ForgetOtp from './pages/ForgotOtp'
import SetNewPassword from './pages/setnewpassword';
import Registerotp from './pages/registerotp';
import Payouts from './pages/payouts';
import Wallet from './pages/wallet';
import Accountwhitelist from './pages/accountwhitelist';
import DeveloperPortal from './pages/DeveloperPortal';
import Collections from './pages/collections';
import Settlement from './pages/settlement';

function App() {
  return (
    <BrowserRouter>  {/* Wrap the entire app inside BrowserRouter */}
      <div>
        
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/Login" element={<Login />} />
          <Route path="/forgetpassword" element={<Forgetpassword />} />
          <Route path="/forgetotp" element={<ForgetOtp />} />
          <Route path="/setnewpassword" element={<SetNewPassword />} />
          <Route path="/Register" element={<Register />} />
          <Route path="/registerotp" element={<Registerotp />} />
          <Route path='/web' element={<Layout/>} />
          <Route path="/dashboard" element={<Layout><Dashboard /></Layout> } />
          <Route path="/collections" element={<Layout><Collections /></Layout> } />
          <Route path="/payouts" element={<Layout><Payouts /></Layout> } />
          <Route path="/wallet" element={<Layout><Wallet /></Layout> } />
          <Route path="/accountwhitelist" element={<Layout><Accountwhitelist /></Layout> } />
          <Route path="/DeveloperPortal" element={<Layout><DeveloperPortal /></Layout> } />
          <Route path="/settlement" element={<Layout><Settlement /></Layout> } />
          {/* <Route path="/resellers" element={<Layout><Resellers /></Layout> } />
          <Route path="/referrals" element={<Layout><Referrals /></Layout> } />
          <Route path="/beneficaries" element={<Layout><Beneficaries /></Layout> } />
          <Route path="/commissions" element={<Layout><Commisions /></Layout> } />
          // 
          <Route path="/monthlyinvoice" element={<Layout><Monthlyinvoice /></Layout> } /> */}
          <Route path="/profile" element={<Layout><Profile /></Layout> } />
          {/* <Route path="/permissions" element={<Layout><Permissions /></Layout> } />
          <Route path="/roles" element={<Layout><Roles /></Layout> } />
          <Route path="/users" element={<Layout><Users /></Layout> } />
          <Route path="/kyc" element={<Layout><Kyc/></Layout>} /> Placeholder for KYC page */}

        </Routes>
      </div>
    </BrowserRouter>
  );
}

export default App;
